import * as React from "react";
import AbstractMedgoSampleInputLanding from "../abstractPrimitive/AbstractMedgoSampleInputLanding.primitive";

function MedgoSampleInputLanding({
  label,
  onChange,
  value,
  placeholder,
  type = "text",
  color = "comet",
  isPassword = false,
  isPasswordVisible = false,
  handleToggleDisplayPassword
}: {
  label: string;
  onChange: (value: string) => void;
  value: string;
  placeholder: string;
  type?: string;
  color?: string;
  isPassword?: boolean;
  isPasswordVisible?: boolean;
  handleToggleDisplayPassword?: () => void;
}) {
  return (
    <AbstractMedgoSampleInputLanding
      label={label}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      type={type}
      color={color}
      isPassword={isPassword}
      handleToggleDisplayPassword={handleToggleDisplayPassword}
      isPasswordVisible={isPasswordVisible}
    />
  );
}

export default MedgoSampleInputLanding;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/MedgoSampleInputLanding.primitive.tsx